// extracted by mini-css-extract-plugin
export default {"footer-btn":"reminder-dashboard_footer-btn__jLVeY"};